"use strict";
/**
 * Based on: https://raw.githubusercontent.com/steemit/condenser/master/src/app/utils/Links.js
 */
// tslint:disable variable-name prefer-for-of

var _slicedToArray = require("/app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var urlChar = '[^\\s"<>\\]\\[\\(\\)]';
var urlCharEnd = urlChar.replace(/\]$/, ".,']"); // insert bad chars to end on

var imagePath = "(?:(?:\\.(?:tiff?|jpe?g|gif|png|svg|ico)|ipfs/[a-z\\d]{40,}))";
var domainPath = "(?:[-a-zA-Z0-9\\._]*[-a-zA-Z0-9])";
var urlChars = "(?:" + urlChar + "*" + urlCharEnd + ")?";

var urlSet = function urlSet() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$domain = _ref.domain,
      domain = _ref$domain === void 0 ? domainPath : _ref$domain,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? "" : _ref$path;

  // urlChars is everything but html or markdown stop chars
  return "https?://".concat(domain, "(?::\\d{2,5})?(?:[/\\?#]").concat(urlChars).concat(path ? path : "", ")").concat(path ? "" : "?");
};
/**
 * Unless your using a 'g' (glob) flag you can store and re-use your regular expression.  Use the cache below.
 *  If your using a glob (for example: replace all), the regex object becomes stateful and continues where it
 *   left off when called with the
 *   same string so naturally the regexp object can't be cached for long.
 */


exports.any = function () {
  var flags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "i";
  return new RegExp(urlSet(), flags);
};

exports.local = function () {
  var flags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "i";
  return new RegExp(urlSet({
    domain: "(?:localhost|(?:.*\\.)?steemit.com)"
  }), flags);
};

exports.remote = function () {
  var flags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "i";
  return new RegExp(urlSet({
    domain: "(?!localhost|(?:.*\\.)?steemit.com)".concat(domainPath)
  }), flags);
};

exports.youTube = function () {
  var flags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "i";
  return new RegExp(urlSet({
    domain: "(?:(?:.*.)?(youtube\\.com|youtu\\.be))"
  }), flags);
};

exports.image = function () {
  var flags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "i";
  return new RegExp(urlSet({
    path: imagePath
  }), flags);
};

exports.imageFile = function () {
  var flags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "i";
  return new RegExp(imagePath, flags);
}; // export const nonImage = (flags = 'i') => new RegExp(urlSet({path: '!' + imageFile}), flags)
// export const markDownImageRegExp = (flags = 'i') => new RegExp('\!\[[\w\s]*\]\(([^\)]+)\)', flags);


exports.default = {
  any: exports.any(),
  local: exports.local(),
  remote: exports.remote(),
  image: exports.image(),
  imageFile: exports.imageFile(),
  youTube: exports.youTube(),
  youTubeId: /(?:(?:youtube.com\/watch\?v=)|(?:youtu.be\/)|(?:youtube.com\/embed\/))([A-Za-z0-9\_\-]+)/i,
  vimeo: /https?:\/\/(?:vimeo.com\/|player.vimeo.com\/video\/)([0-9]+)\/*/,
  vimeoId: /(?:vimeo.com\/|player.vimeo.com\/video\/)([0-9]+)/,
  // simpleLink: new RegExp(`<a href="(.*)">(.*)<\/a>`, 'ig'),
  ipfsPrefix: /(https?:\/\/.*)?\/ipfs/i,
  twitch: /https?:\/\/(?:www.)?twitch.tv\/(?:(videos)\/)?([a-zA-Z0-9][\w]{3,24})/i
};
/**
 * Returns a new object extended from outputParams with [key] == inputParams[key] if the value is in allowedValues
 * @param outputParams
 * @param inputParamsco
 * @param key
 * @param allowedValues
 * @returns {*}
 */

exports.addToParams = function (outputParams, inputParams, key, allowedValues) {
  var respParams = Object.assign({}, outputParams);

  if (inputParams[key] && allowedValues.indexOf(inputParams[key]) > -1) {
    respParams[key] = inputParams[key];
  }

  return respParams;
};

exports.makeParams = function (params, prefix) {
  var paramsList = [];

  if (params.constructor === Array) {
    paramsList = params;
  } else {
    Object.entries(params).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];

      paramsList.push("".concat(key, "=").concat(value));
    });
  }

  if (paramsList.length > 0) {
    return (prefix !== false ? typeof prefix === "string" ? prefix : "?" : "") + paramsList.join("&");
  }

  return "";
};